import React from 'react'
import Draggable from './Draggable';
import { v4 as uuidv4 } from 'uuid';
import { getBoundingClientRect } from '../../utils/functions'
import DraggableG from './DraggableG';

class DraggableGrid extends React.Component {
    constructor() {
        super()
        this.state = {
            shadowTop: null,
            shadowLeft: null
        }
    }



    dragStarted = (id) => {
        let bound = this[id].draggableItem.getBoundingClientRect()
        console.log(bound)
        console.log(id)

        this.setState({ dragId: id, shadowWidth: bound.width, shadowHeight: bound.height })
    }

    changeShadowPosition = (e) => {
        // console.log("CHANGE SHADOW")
        if (this.shadowChild) {
            this.shadowChild.style.top = (e.clientY - 2) + 'px'
            this.shadowChild.style.left = e.clientX + 2 + 'px'

        }
    }

    dragOver = (id) => {

        if (this.state.dragId !== id && this.dragOverId != id) {
            this.dragOverId = id
            this.animateSorting(this.state.dragId, id)
        }
    }



    animateSorting = (dragId, overId) => {
        let dragIndex = null
        let overIndex = null
        // console.log("AMINATE")
        // console.log(this.props.data)
        this.props.data.forEach((element, index) => {
            // console.log(element.id)
            let id = element.id ?? element._id

            // console.log(id)
            // console.log(dragId)

            if (id === dragId) {
                dragIndex = index
            }
            if (id === overId) {
                overIndex = index
            }
        });


        if (dragIndex !== null && overIndex !== null) {

            this.bounds = this.getElementsBounds(this.props.data)

            // console.log(this.bounds)

            let data = this.props.data
            let temp = data[dragIndex]
            data.splice(dragIndex, 1)
            data.splice(overIndex, 0, temp)

            this.props.updatedata(data, () => {
                let newBounds = this.getElementsBounds(this.props.data)

                requestAnimationFrame(() => {
                    Object.keys(this.bounds).forEach(key => {

                        const deltaX = this.bounds[key].left - newBounds[key].left;
                        const deltaY = this.bounds[key].top - newBounds[key].top;

                        if (deltaX !== 0 || deltaY !== 0) {

                            let domNode = this[key].draggableItem
                            domNode.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
                            domNode.style.transition = 'transform 0s';
                            requestAnimationFrame(() => {

                                domNode.style.transform = '';
                                domNode.style.transition = 'transform 300ms';

                            });
                        }
                    });
                    let dragOverId = this.dragOverId
                    setTimeout(() => {
                        if (dragOverId === this.dragOverId) {
                            this.dragOverId = null
                        }
                    }, 350);
                })
            })

        }
    }

    getElementsBounds(data) {
        let bounds = {}
        data.forEach(element => {
            let id = element.id ?? element._id

            if (this[id]) {
                // console.log(this[id])
                bounds[id] = getBoundingClientRect(this[id].draggableItem)
            }
        });
        return bounds
    }

    onDrop = (id) => {
    }

    onDrag = (e) => {
        this.changeShadowPosition(e)
    }

    dragEnd = (e) => {
        console.log("DRAG END")
        this.setState({ dragId: null })
        this.dragOverId = null
    }


    render() {
        let shadowChild
        if (this.props.children) {
            var children = []
            if (Array.isArray(this.props.children)) {
                var children = this.props.children.map(function (child, i) {
                    if (child.props.id === this.state.dragId) {
                        shadowChild = React.cloneElement(child)
                    }
                    // console.log(child)
                    return (


                        <DraggableG ref={el => this[child.key] = el} id={child.key} key={'draggable' + child.key} onDrag={this.onDrag} dragStarted={this.dragStarted} dragOver={this.dragOver} onDrop={this.onDrop} dragEnd={this.dragEnd} col={child.props.col} extraClass={child.props.extraClass}>
                            {React.cloneElement(child,
                                { key: child.key }
                            )}

                            {child.key === this.state.dragId && (
                                <div className="drop-ghost" style={{pointerEvents:'none', zIndex: 2, position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', backgroundColor: 'rgba(230,240,245,0.9)', border: '1px dotted #007aff40' }}></div>
                            )}
                        </DraggableG>

              
                    )

                }, this);
            } else {
                var children = React.cloneElement(this.props.children,
                    { lastStage: this.lastStage, nextStage: this.nextStage, changeStage: this.changeStage, }
                )

            }

            // console.log(children)

            return (
                <div ref={el => this.draggableList = el} className={"w-100 draggableList  m-0 " + (this.state.dragId ? "isDragging" : '') + (this.props.notRow ? ' ':' row')} >

                    {children}

                    {shadowChild && (
                        <div className=" blur-back" ref={el => this.shadowChild = el} style={{pointerEvents:'none', width: this.state.shadowWidth, height: this.state.shadowHeight, overflow: 'hidden', backgroundColor: '#ffffffcc', boxShadow: '0px 0px 15px #00000010', zIndex: 5, position: 'fixed', transform: 'rotate(0.5deg)' }}>
                            {shadowChild}
                        </div>
                    )}

                </div>
            )
        }
        else {
            return <div></div>
        }
    }

}

export default DraggableGrid
